import { IUserPermissionsModel } from '../interfaces/user-permissions.interface';
import IUserPermissions = Authorization.IUserPermissions;
import IProductFeature = Authorization.IProductFeature;
import IGridicsSubscription = Authorization.IGridicsSubscription;
import * as _ from 'lodash';

export class UserPermissions implements IUserPermissionsModel {
    UserId: number;
    PermissionId: number;
    LevelPermission: number;
    Features: IProductFeature[];
    Subscriptions: IGridicsSubscription[];

    constructor(userData: IUserPermissions) {
        this.UserId = userData.UserId;
        this.PermissionId = userData.PermissionId;
        this.LevelPermission = userData.LevelPermission;
        this.Features = userData.Features;
        this.Subscriptions = userData.Subscriptions;
    }

    get hasFeatures() {
        return !!_.get(this, 'Features.length', 0);
    }

    findFeatureByName(featureName: string): IProductFeature {
        return this.hasFeatures ? this.Features.find(f => f.Name === featureName) : null;
    }

    get hasSubscriptions() {
        return !!_.get(this, 'Subscriptions.length', 0);
    }

    findSubscriptionByName(subscriptionName: string) {
        return this.hasSubscriptions ? this.Subscriptions.find(f => f.Name === subscriptionName) : null;
    }
}
